module.exports = __webpack_public_path__ + "img/share-03.13625085.svg";